const SVG_NS = "http://www.w3.org/2000/svg";

// ここを増やすと「塗れる色」を増やせます（現状は赤1色のみ）。
const COLORS = [{ hex: "#EA463D" }];

const BASE_FONT_STACK = "'Zen Kaku Gothic New', 'Hiragino Sans', 'Yu Gothic', sans-serif";
const KLEE_FONT_STACK = "'Klee One', 'Hiragino Sans', 'Yu Gothic', sans-serif";
const MOCHIY_FONT_STACK = "'Mochiy Pop One', sans-serif";

// ここが表示テキスト本体です。
// - 文字列: 通常行
// - 配列: 部分的にフォントやサイズを変える行
const LINE_ROWS = [
  "私たちが大切にしているのは、",
  [
    { text: "家づくりの時間そのものを" },
    { text: "楽しめる", font: MOCHIY_FONT_STACK, size: 55 },
    { text: "こと、" },
  ],
  [{ text: "豊かなくらし", font: KLEE_FONT_STACK, size: 58 }, { text: "を実現することです。" }],
  "図面を囲んで話し合う瞬間も、",
  "現場で職人がひと手間かける姿も、",
  "住まいが少しずつカタチになっていく過程も、",
  "お客様といっしょに共有できるわたしたちでありたいと考えています。",
];

const LINE_ROWS_SP = [
  "私たちが大切にしているのは、",
  [
    { text: "家づくりの時間そのものを" },
    { text: "楽しめる", font: MOCHIY_FONT_STACK, size: 55 },
    { text: "こと、" },
  ],
  [{ text: "豊かなくらし", font: KLEE_FONT_STACK, size: 58 }, { text: "を実現することです。" }],
  "図面を囲んで話し合う瞬間も、",
  "現場で職人がひと手間かける姿も、",
  "住まいが少しずつカタチになっていく過程も、",
  "お客様といっしょに共有できる",
  "わたしたちでありたいと考えています。",
];


const BREAKPOINT_SP = 768;

const FONT_CLAMP_MIN_PX = 20;
const FONT_CLAMP_VW = 2.2;
const FONT_CLAMP_MAX_PX = 38;
const FONT_CLAMP_MIN_PX_SP = 26;
const FONT_CLAMP_VW_SP = 6.8;
const FONT_CLAMP_MAX_PX_SP = 34;
// アクセント文字の size(55/58など) を、実際のpxへ換算する際の基準値。
const ACCENT_REF_BASE_PX = 28;
// 行間（基準フォントサイズ × この値）。大きいほど行が離れる。
const LINE_LEADING_NORMAL = 2.5; // 通常行（文字列のみの行）
const LINE_LEADING_ACCENT = 3.0; // 大きい文字を含む行（配列で size 指定あり）
const PAD_X = 8;
const PAD_Y = 10;
const BASE_COLOR = "#1f1f1f";
// iOS Safari はスクロール時に innerWidth が数 px 変動することがある。
const LAYOUT_WIDTH_EPS = 8;

function isSpView() {
  return window.matchMedia(`(max-width: ${BREAKPOINT_SP}px)`).matches;
}

function getLineRows() {
  return isSpView() ? LINE_ROWS_SP : LINE_ROWS;
}

function baseFontSizeClampedPx() {
  const isSp = isSpView();
  const minPx = isSp ? FONT_CLAMP_MIN_PX_SP : FONT_CLAMP_MIN_PX;
  const maxPx = isSp ? FONT_CLAMP_MAX_PX_SP : FONT_CLAMP_MAX_PX;
  const vw = isSp ? FONT_CLAMP_VW_SP : FONT_CLAMP_VW;
  const fromVw = window.innerWidth * (vw / 100);
  return Math.min(maxPx, Math.max(minPx, fromVw));
}

function accentFontPx(partSize, baseFs) {
  return Math.round((partSize * baseFs) / ACCENT_REF_BASE_PX);
}

function lineMaxFont(row, baseFs) {
  if (typeof row === "string") return baseFs;
  return Math.max(baseFs, ...row.map((p) => (p.size != null ? accentFontPx(p.size, baseFs) : baseFs)));
}

/** 配列行のうち、size 指定があるパーツを含む行を「大きい文字の行」とみなす */
function isAccentRow(row) {
  return Array.isArray(row) && row.some((part) => part.size != null);
}

/** 2行のあいだの行間倍率（どちらかが大きい文字行なら ACCENT、両方通常なら NORMAL） */
function lineGapMultiplier(prevRow, row) {
  if (isAccentRow(prevRow) || isAccentRow(row)) {
    return LINE_LEADING_ACCENT;
  }
  return LINE_LEADING_NORMAL;
}

function lineBaselines(rows, baseFs) {
  const out = [];
  rows.forEach((row, li) => {
    const mf = lineMaxFont(row, baseFs);
    if (li === 0) {
      out.push(PAD_Y + Math.round(mf * 0.88));
    } else {
      const prevRow = rows[li - 1];
      const pmf = lineMaxFont(prevRow, baseFs);
      const mult = lineGapMultiplier(prevRow, row);
      const gapFromLeading = Math.round(baseFs * mult);
      const minVisual = Math.round(Math.max(pmf, mf) * 0.75);
      out.push(out[li - 1] + Math.max(gapFromLeading, minVisual));
    }
  });
  return out;
}

function appendLineContent(textEl, row, baseFs) {
  if (typeof row === "string") {
    textEl.textContent = row;
    return;
  }
  row.forEach((part) => {
    const ts = document.createElementNS(SVG_NS, "tspan");
    ts.textContent = part.text;
    ts.setAttribute("font-size", part.size != null ? String(accentFontPx(part.size, baseFs)) : String(baseFs));
    ts.setAttribute("font-family", part.font || BASE_FONT_STACK);
    if (part.weight != null) ts.setAttribute("font-weight", String(part.weight));
    textEl.appendChild(ts);
  });
}

function measureRowWidth(row, baseFs) {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  if (!ctx) return 0;
  if (typeof row === "string") {
    ctx.font = `500 ${baseFs}px ${BASE_FONT_STACK}`;
    return ctx.measureText(row).width;
  }
  return row.reduce((w, part) => {
    const fs = part.size != null ? accentFontPx(part.size, baseFs) : baseFs;
    const family = part.font || BASE_FONT_STACK;
    ctx.font = `${part.weight || 500} ${fs}px ${family}`;
    return w + ctx.measureText(part.text).width;
  }, 0);
}

function initHomeAboutPaint() {
  const root = document.querySelector("[data-home-about-paint]");
  if (!root || root.dataset.paintReady === "1") return;
  root.dataset.paintReady = "1";

  const svgEl = root.querySelector(".homeAboutPaint-svg");
  const svgDefs = root.querySelector(".homeAboutPaint-defs");
  const textGroup = root.querySelector(".homeAboutPaint-textGroup");
  const roller = root.querySelector(".homeAboutPaint-crayon");
  const ghost = root.querySelector(".homeAboutPaint-ghost");

  if (!svgEl || !svgDefs || !textGroup || !roller || !ghost) return;

  let masks = [];
  let paintRadius = {};
  let paintStrokes = [];
  let activeDrag = null;
  let lastContainerWidth = 0;
  let lastIsSp = null;
  let layoutRaf = 0;

  function clamp(v, min, max) {
    return Math.min(max, Math.max(min, v));
  }

  /**
   * ポインタを「要素の中心」に合わせたときの、root 内の left/top（px）。
   * ghost は root の直下なのでこの座標でそのまま置ける。
   */
  function ghostLocalFromClient(clientX, clientY) {
    const rect = root.getBoundingClientRect();
    const gw = ghost.offsetWidth || 80;
    const gh = ghost.offsetHeight || 80;
    let left = clientX - rect.left - gw / 2;
    let top = clientY - rect.top - gh / 2;
    left = clamp(left, 0, Math.max(0, rect.width - gw));
    top = clamp(top, 0, Math.max(0, rect.height - gh));
    return { left, top };
  }

  /**
   * ローラーは aside > crayons 内にあり、position:absolute の包含ブロックが
   * offsetParent（多くの場合 .homeAboutPaint-aside）になる。
   * root 基準の計算のまま left/top を指定すると意図しない位置になるため、
   * ビューポート座標で中心合わせしてから offsetParent 基準に変換する。
   */
  function rollerLocalFromClient(clientX, clientY) {
    const rootRect = root.getBoundingClientRect();
    const rw = roller.offsetWidth || 80;
    const rh = roller.offsetHeight || 80;
    let leftGlobal = clientX - rw / 2;
    let topGlobal = clientY - rh / 2;
    leftGlobal = clamp(leftGlobal, rootRect.left, rootRect.right - rw);
    topGlobal = clamp(topGlobal, rootRect.top, rootRect.bottom - rh);
    const parent = roller.offsetParent || root;
    const pr = parent.getBoundingClientRect();
    return {
      left: leftGlobal - pr.left,
      top: topGlobal - pr.top,
    };
  }

  function clientToSvgPoint(clientX, clientY) {
    const rect = svgEl.getBoundingClientRect();
    const vb = svgEl.viewBox.baseVal;
    const scaleX = rect.width / vb.width || 1;
    const scaleY = rect.height / vb.height || 1;
    return {
      x: (clientX - rect.left) / scaleX,
      y: (clientY - rect.top) / scaleY,
      scale: scaleX,
    };
  }

  function getContainerWidth() {
    return Math.round(
      svgEl.clientWidth || root.querySelector(".homeAboutPaint-main")?.clientWidth || 0
    );
  }

  function appendPaintCircle(idx, cx, cy, r) {
    if (!masks[idx]) return;
    const circle = document.createElementNS(SVG_NS, "circle");
    circle.setAttribute("cx", String(cx));
    circle.setAttribute("cy", String(cy));
    circle.setAttribute("r", String(r));
    circle.setAttribute("fill", "white");
    masks[idx].appendChild(circle);
  }

  function restorePaintStrokes() {
    paintStrokes.forEach(({ idx, cx, cy, r }) => {
      appendPaintCircle(idx, cx, cy, r);
    });
  }

  function buildSVG() {
    const savedPaintRadius = { ...paintRadius };

    svgDefs.innerHTML = "";
    textGroup.innerHTML = "";
    masks = [];

    const containerW = getContainerWidth() || 660;
    const rows = getLineRows();
    const fontSize = baseFontSizeClampedPx();
    const baselines = lineBaselines(rows, fontSize);
    const lastMf = lineMaxFont(rows[rows.length - 1], fontSize);
    const totalH = baselines[rows.length - 1] + Math.round(lastMf * 0.35) + PAD_Y;
    let maxLineW = 0;
    rows.forEach((row) => {
      maxLineW = Math.max(maxLineW, measureRowWidth(row, fontSize));
    });
    const vbW = Math.max(containerW, Math.ceil(maxLineW + PAD_X * 2));

    svgEl.setAttribute("viewBox", `0 0 ${vbW} ${totalH}`);

    rows.forEach((row, li) => {
      const t = document.createElementNS(SVG_NS, "text");
      t.setAttribute("x", PAD_X);
      t.setAttribute("y", baselines[li]);
      t.setAttribute("font-size", fontSize);
      t.setAttribute("font-weight", "500");
      t.setAttribute("font-family", BASE_FONT_STACK);
      t.setAttribute("fill", BASE_COLOR);
      t.setAttribute("letter-spacing", "-1");
      appendLineContent(t, row, fontSize);
      textGroup.appendChild(t);
    });

    COLORS.forEach((c, i) => {
      const mask = document.createElementNS(SVG_NS, "mask");
      mask.setAttribute("id", `home-about-pm-${i}`);
      mask.setAttribute("maskUnits", "userSpaceOnUse");

      const bg = document.createElementNS(SVG_NS, "rect");
      bg.setAttribute("x", "0");
      bg.setAttribute("y", "0");
      bg.setAttribute("width", String(vbW));
      bg.setAttribute("height", String(totalH));
      bg.setAttribute("fill", "black");
      mask.appendChild(bg);
      svgDefs.appendChild(mask);
      masks.push(mask);

      rows.forEach((row, li) => {
        const t = document.createElementNS(SVG_NS, "text");
        t.setAttribute("x", PAD_X);
        t.setAttribute("y", baselines[li]);
        t.setAttribute("font-size", fontSize);
        t.setAttribute("font-weight", "500");
        t.setAttribute("font-family", BASE_FONT_STACK);
        t.setAttribute("fill", c.hex);
        t.setAttribute("letter-spacing", "-1");
        t.setAttribute("mask", `url(#home-about-pm-${i})`);
        appendLineContent(t, row, fontSize);
        textGroup.appendChild(t);
      });
    });

    paintRadius = savedPaintRadius;
    restorePaintStrokes();
  }

  function moveGhost(x, y) {
    // ゴーストローラーは homeAboutPaint（root）内だけで動作させる。
    const p = ghostLocalFromClient(x, y);
    ghost.style.left = `${p.left}px`;
    ghost.style.top = `${p.top}px`;
  }

  function paint(cx, cy) {
    if (!activeDrag) return;
    const { x: ux, y: uy, scale } = clientToSvgPoint(cx, cy);
    const idx = activeDrag.idx;
    // 塗りの太さ・伸び方:
    // - 初期値: 12
    // - 1フレームごとの増分: +5
    // - 最大半径: 72
    const rScreen = Math.min((paintRadius[idx] || 12) + 5, 72);
    paintRadius[idx] = rScreen;
    const r = rScreen / scale;

    if (!masks[idx]) return;
    paintStrokes.push({ idx, cx: ux, cy: uy, r });
    appendPaintCircle(idx, ux, uy, r);
  }

  function onPointerMove(e) {
    if (!activeDrag) return;
    activeDrag.lastX = e.clientX;
    activeDrag.lastY = e.clientY;
    moveGhost(e.clientX, e.clientY);
    paint(e.clientX, e.clientY);
  }

  function onTouchMove(e) {
    if (!activeDrag || !e.touches[0]) return;
    e.preventDefault();
    const touch = e.touches[0];
    activeDrag.lastX = touch.clientX;
    activeDrag.lastY = touch.clientY;
    moveGhost(touch.clientX, touch.clientY);
    paint(touch.clientX, touch.clientY);
  }

  function endDrag(e) {
    if (activeDrag) {
      let placeX = activeDrag.lastX ?? 0;
      let placeY = activeDrag.lastY ?? 0;
      if (e && typeof e.clientX === "number" && typeof e.clientY === "number") {
        placeX = e.clientX;
        placeY = e.clientY;
      } else if (e && e.changedTouches && e.changedTouches[0]) {
        placeX = e.changedTouches[0].clientX;
        placeY = e.changedTouches[0].clientY;
      }
      const p = rollerLocalFromClient(placeX, placeY);
      roller.style.position = "absolute";
      // 離した座標の中心にローラーが来る（ゴーストと同じ基準）。
      roller.style.left = `${p.left}px`;
      roller.style.top = `${p.top}px`;
      roller.style.zIndex = "1001";
      roller.style.visibility = "visible";
    }
    activeDrag = null;
    root.classList.remove("is-dragging");
    ghost.classList.remove("is-active");
    window.removeEventListener("mousemove", onPointerMove);
    window.removeEventListener("mouseup", endDrag);
    window.removeEventListener("touchmove", onTouchMove);
    window.removeEventListener("touchend", endDrag);
    window.removeEventListener("touchcancel", endDrag);
  }

  function beginDrag(x, y) {
    activeDrag = { idx: 0, lastX: x, lastY: y };
    root.classList.add("is-dragging");
    // ドラッグ中は元のローラーを隠し、ゴーストのみ表示します。
    roller.style.visibility = "hidden";
    moveGhost(x, y);
    ghost.classList.add("is-active");
    window.addEventListener("mousemove", onPointerMove);
    window.addEventListener("mouseup", endDrag);
    window.addEventListener("touchmove", onTouchMove, { passive: false });
    window.addEventListener("touchend", endDrag);
    window.addEventListener("touchcancel", endDrag);
  }

  roller.addEventListener("mousedown", (e) => {
    e.preventDefault();
    beginDrag(e.clientX, e.clientY);
  });
  roller.addEventListener(
    "touchstart",
    (e) => {
      if (!e.touches[0]) return;
      e.preventDefault();
      beginDrag(e.touches[0].clientX, e.touches[0].clientY);
    },
    { passive: false }
  );

  /**
   * レイアウト幅・SP 判定が実質変わったときだけ SVG を再構築する。
   * 塗りデータは paintStrokes に保持し、再構築後も復元する。
   */
  function shouldRebuildLayout() {
    const containerW = getContainerWidth();
    const sp = isSpView();
    if (lastContainerWidth === 0) return true;
    if (sp !== lastIsSp) return true;
    return Math.abs(containerW - lastContainerWidth) >= LAYOUT_WIDTH_EPS;
  }

  function handleLayoutChange() {
    if (!shouldRebuildLayout()) return;
    lastContainerWidth = getContainerWidth();
    lastIsSp = isSpView();
    buildSVG();
  }

  function scheduleLayoutCheck() {
    if (layoutRaf) return;
    layoutRaf = requestAnimationFrame(() => {
      layoutRaf = 0;
      handleLayoutChange();
    });
  }

  function syncLayoutState() {
    lastContainerWidth = getContainerWidth();
    lastIsSp = isSpView();
  }

  const cleanupFns = [];
  if (typeof ResizeObserver !== "undefined") {
    const resizeObserver = new ResizeObserver(scheduleLayoutCheck);
    resizeObserver.observe(svgEl);
    cleanupFns.push(() => resizeObserver.disconnect());
  } else {
    window.addEventListener("resize", scheduleLayoutCheck);
    cleanupFns.push(() => window.removeEventListener("resize", scheduleLayoutCheck));
  }

  const spMedia = window.matchMedia(`(max-width: ${BREAKPOINT_SP}px)`);
  spMedia.addEventListener("change", scheduleLayoutCheck);
  cleanupFns.push(() => spMedia.removeEventListener("change", scheduleLayoutCheck));

  root.__homeAboutPaintCleanup?.();
  root.__homeAboutPaintCleanup = () => {
    cleanupFns.forEach((fn) => fn());
    if (layoutRaf) {
      cancelAnimationFrame(layoutRaf);
      layoutRaf = 0;
    }
  };

  syncLayoutState();
  buildSVG();
}

document.addEventListener("DOMContentLoaded", initHomeAboutPaint);
document.addEventListener("swup:replaced", initHomeAboutPaint);
document.addEventListener("swup:home", initHomeAboutPaint);
